/**
 * «Юниверситет» (28.09): картинки и ролики пакета — только по подписанным ссылкам,
 * ролики с preload="none" (ТЗ). Ссылка «держится» за элементом: плановое обновление
 * подписей (раз в ~5 ч) не должно перезапускать ролик, который человек сейчас смотрит.
 * Свежую подпись берём, только если старая не загрузилась (истекла).
 */
import { useEffect, useState } from "react";
import { posterOf, useMediaUrl } from "./ctx";
import { useTracks } from "./TrackPlayer";

function useStableSrc(fresh: string | undefined): [string | undefined, () => void] {
  const [src, setSrc] = useState(fresh);
  /* ссылка «замораживается», чтобы обновление подписей не перезапускало видео; после ошибки
     (протухла, пока приложение спало) берём ПЕРВУЮ новую подпись, даже если она пришла позже */
  const [errored, setErrored] = useState(false);
  useEffect(() => {
    if (!src && fresh) setSrc(fresh);
    else if (errored && fresh && fresh !== src) { setSrc(fresh); setErrored(false); }
  }, [src, fresh, errored]);
  const retry = () => { if (fresh && fresh !== src) setSrc(fresh); else setErrored(true); };
  return [src, retry];
}

/* part / data-fb-*: замечания (16.10) — к какой картинке или ролику пакета замечание */
export function UniImg({ rel, className, alt = "", part = "картинка" }: { rel: string; className?: string; alt?: string; part?: string }) {
  const url = useMediaUrl();
  const [src, retry] = useStableSrc(url(rel));
  if (!src) return <div className={className} aria-hidden="true" data-fb-part={part} data-fb-media={rel} />;
  return <img className={className} src={src} alt={alt} loading="lazy" decoding="async" onError={retry} data-fb-part={part} data-fb-media={rel} />;
}

export function UniVideo({ rel, className, part = "видео" }: { rel: string; className?: string; part?: string }) {
  const url = useMediaUrl();
  const tracks = useTracks();
  const [src, retry] = useStableSrc(url(rel));
  const [poster, posterRetry] = useStableSrc(url(posterOf(rel)));
  return (
    <video
      className={className}
      src={src}
      poster={poster}
      controls
      playsInline
      preload="none"
      onError={() => { retry(); posterRetry(); }}
      onPlay={() => tracks?.stop()} // сценка со своим звуком — музыку глушим
      data-fb-part={part}
      data-fb-media={rel}
    />
  );
}
